module.exports = "/_next/static/images/96e2ee512a726c01614a5ad46e9e4b35-business-insider.png";